import React, { useEffect, useState } from 'react';
import SiteCard from './SiteCard';
import Pagination from '@hedinbil/hedin-ui/dist/shop/components/pagination/Pagination';
import { hrefToSitecoreLink } from '../../Project/bavaria-no/utils/hrefToSitecoreLink';
import {
  CHECK_QUERY_PARAMS,
  GET_QUERY_PARAMS,
  INITIAL_SITE_FILTERS,
  UPDATE_ALL_DYNAMIC_FILTERS,
  UPDATE_QUERY_PARAMS_URL,
  UPDATE_SITES,
  UPDATE_TOTAL_COUNT,
} from '../../Feature/hedin-filters/actions/types';
import { connect } from 'react-redux';
import { filterActions } from '../../Feature/hedin-filters/actions/filterActions';
import Filter from '../../Project/bavaria-no/components/Filter/Filter';
import FilterResetButton from '../../Project/bavaria-no/components/Filter/FilterResetButton';
import FilterButton from '../../Project/bavaria-no/components/Filter/FilterButton';
import Spinner from '../../Foundation/components/Spinner';
import { hasValidQueryParams } from '@hedinbil/hedin-ui/dist/shop/utils/hasValidQueryParams';
import { getTotalActiveFilters } from '@hedinbil/hedin-ui/dist/shop/utils/getTotalActiveFilters';
import noImage from '../../Project/bavaria-no/assets/img/no-site-img-small.png';
import PageEditorWrapper from '../../Foundation/components/PageEditorWrapper';
import { getVariantImage } from '../../Project/bavaria-no/utils/getVariantImage';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { getDynamicFilterItems } from '../../Feature/hedin-filters/helpers/getDynamicFilterItems';
import {
  saveScrollPosition,
  scrollToSavedPosition,
} from '../../Feature/hedin-filters/helpers/scrollPosition';
import checkQueryParams from '../../Project/bavaria-no/utils/queryParams';

const SiteList = (props) => {
  const {
    fields,
    filterState,
    sitecoreContext,
    sites,
    currentQuery,
    totalCount: { sites: totalCount },
  } = props;
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [activeFilters, setActiveFilters] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isEditing = sitecoreContext && sitecoreContext.pageEditing;
  const perPageVal = fields?.datasourceItems?.SiteListPageSize?.value;
  const perPage = perPageVal ? perPageVal : 24;
  const totalCountIsShowing = totalCount < perPage * pageNumber ? totalCount : perPage * pageNumber;
  const showingNumber = sites.length > 0 ? totalCountIsShowing : 0;
  const filterType = 'Site';

  const setSites = (sites) => {
    props.filterActions(UPDATE_SITES, sites, { filterType });
  };

  const setTotalCount = (value) => {
    props.filterActions(UPDATE_TOTAL_COUNT, value, { filterType });
  };

  useEffect(() => {
    props.filterActions(INITIAL_SITE_FILTERS, fields?.filters);
    props.filterActions(CHECK_QUERY_PARAMS, null, { filterType });
    const pageNumberParam = checkQueryParams('page');

    if (hasValidQueryParams(fields?.filters) || pageNumberParam) {
      onFilter(Number(pageNumberParam));
    } else {
      setSites(fields?.sites || []);
      setTotalCount(Number(fields?.totalCount));
    }
    scrollToSavedPosition();
  }, []);

  const onFilter = (argPageNumber = 0) => {
    setIsLoading(true);
    const queryParams = props.filterActions(GET_QUERY_PARAMS, null, { filterType });

    const newPerPage = argPageNumber !== 0 ? (argPageNumber + 1) * perPage : perPage;

    getDynamicFilterItems({
      pageNumber: 0,
      perPage: newPerPage,
      queryParams,
      currentQuery,
      filterType,
      filterActions: props.filterActions,
      eventType: 'FILTER',
    }).then((res) => {
      setPageNumber(1);
      setIsLoading(false);
      setActiveFilters(getTotalActiveFilters(fields?.filters));

      const pageNumberParam = checkQueryParams('page');

      if (pageNumberParam) {
        setPageNumber(Number(pageNumberParam) + 1);
      }

      if (res?.filter) {
        props.filterActions(UPDATE_ALL_DYNAMIC_FILTERS, res?.filter, {
          parentValue: queryParams,
          filterType,
        });
      }
    });
  };

  const onPaginate = () => {
    setIsLoading(true);
    const queryParams = props.filterActions(GET_QUERY_PARAMS, null, { filterType });
    props.filterActions(UPDATE_QUERY_PARAMS_URL, null, { parentValue: pageNumber, filterType });

    getDynamicFilterItems({
      pageNumber,
      perPage,
      queryParams,
      filterType,
      filterActions: props.filterActions,
      currentQuery: null,
      eventType: 'PAGINATE',
    }).then(() => {
      setPageNumber(pageNumber + 1);
      setIsLoading(false);
    });
  };

  const onUpdateList = (newSites) => {
    setSites([...newSites]);

    setTimeout(() => {
      setActiveFilters(getTotalActiveFilters(filterState.siteFilters, ''));
    }, 50);
  };

  return (
    <div className="sheet">
      <div className="h-mb-2">
        <FilterButton
          text="Filter"
          onClick={() => setFilterIsOpen(!filterIsOpen)}
          activeFilters={activeFilters}
        />
        {activeFilters && (
          <div className="card__filter-chips d-flex">
            <FilterResetButton
              filterActions={props.filterActions}
              onClear={() => onFilter()}
              filterType="Site"
            />
          </div>
        )}
      </div>
      <div className="card__list-wrapper">
        <div className="card__list">
          {sites.map((item, index) => (
            <SiteCard
              image={
                item?.images[0]?.variants !== null
                  ? getVariantImage(item?.images[0]?.variants, 'preview')
                  : noImage
              }
              item={item}
              address={item?.address}
              phone={item?.phone}
              link={hrefToSitecoreLink(item?.link)}
              onClick={() => saveScrollPosition()}
              key={index}
              isEditing={isEditing}
            />
          ))}
        </div>
      </div>
      {isLoading && <Spinner type={Spinner.types.wave} />}
      {!isLoading && sites.length === 0 && (
        <h2 className="text-center">Hittade inga anläggningar med valt filter...</h2>
      )}
      <Pagination
        showing={showingNumber}
        totalResults={totalCount}
        disabled={showingNumber === totalCount}
        isLoading={isLoading}
        buttonText="Vis flere"
        className="h-mt-5"
        onClick={() => onPaginate()}
      />
      <Filter
        isOpen={filterIsOpen}
        onClose={() => setFilterIsOpen(false)}
        facets={filterState.siteFilters}
        filterActions={props.filterActions}
        onFilter={() => onFilter()}
        onClear={() => onFilter()}
        filterType="Site"
        resetPageNumber={() => setPageNumber(1)}
        datasourceItems={fields?.datasourceItems}
        perPage={perPage}
        updateTotalCount={(newTotalCount) => setTotalCount(newTotalCount)}
        onUpdateList={(newSites) => onUpdateList(newSites)}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  filterState: state.filter,
  sites: state.filter.sites,
  currentQuery: state.filter.currentQuery,
  totalCount: state.filter.totalCount,
});

export default withSitecoreContext()(
  connect(mapStateToProps, { filterActions })(PageEditorWrapper(SiteList))
);
